import { render } from "./SignUpButton.vue?vue&type=template&id=34422a5f&scoped=true"
import script from "./SignUpButton.vue?vue&type=script&lang=js"
export * from "./SignUpButton.vue?vue&type=script&lang=js"

import "./SignUpButton.vue?vue&type=style&index=0&id=34422a5f&lang=scss&scoped=true"
import "./SignUpButton.vue?vue&type=style&index=1&id=34422a5f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34422a5f"]])

export default __exports__